import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 126.316 101.208',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Grupo_6001" data-name="Grupo 6001" transform="translate(-314 -156)">
      <path
        id="male-solid"
        className="icon"
        d="M18.976,0A12.651,12.651,0,1,1,6.325,12.651,12.651,12.651,0,0,1,18.976,0m9.488,28.465H26.219a17.372,17.372,0,0,1-14.485,0H9.488A9.488,9.488,0,0,0,0,37.953V64.836A4.744,4.744,0,0,0,4.744,69.58H7.907V96.463a4.744,4.744,0,0,0,4.744,4.744H25.3a4.744,4.744,0,0,0,4.744-4.744V69.58h3.163a4.744,4.744,0,0,0,4.744-4.744V37.953A9.488,9.488,0,0,0,28.465,28.465Z"
        transform="translate(314 156)"
        fill={fill}
      />
      <path
        id="female-solid"
        className="icon"
        d="M31.712,0A12.651,12.651,0,1,1,19.061,12.651,12.651,12.651,0,0,1,31.712,0M55.291,70.011,45.8,32.058a4.744,4.744,0,0,0-4.6-3.593H38.955a17.372,17.372,0,0,1-14.485,0H22.224a4.744,4.744,0,0,0-4.6,3.593L8.134,70.011a4.746,4.746,0,0,0,4.6,5.895h11.07V96.463a4.744,4.744,0,0,0,4.744,4.744h6.325a4.744,4.744,0,0,0,4.744-4.744V75.906h11.07a4.746,4.746,0,0,0,4.6-5.895Z"
        transform="translate(384.881 156)"
        fill={fill}
      />
      <path
        id="child-solid"
        className="icon"
        d="M12.231,7.339a7.339,7.339,0,1,1,7.339,7.339A7.338,7.338,0,0,1,12.231,7.339Zm25.953.14a3.261,3.261,0,0,0-4.612,0l-8.829,8.829H14.4L5.568,7.478A3.262,3.262,0,0,0,.956,12.091L10.6,21.736V48.924a3.262,3.262,0,0,0,3.262,3.262h1.631a3.262,3.262,0,0,0,3.262-3.262V37.508h1.631V48.924a3.262,3.262,0,0,0,3.262,3.262h1.631a3.262,3.262,0,0,0,3.262-3.262V21.736l9.645-9.645A3.261,3.261,0,0,0,38.184,7.478Z"
        transform="translate(353.731 205.022)"
        fill={fill}
        opacity="0.61"
      />
    </g>
  </svg>
);

export default SVG;
